import { formatWeekdayDateOrDash } from "@shared-core/domain/formatters";

// An item's History, the same on the order page's CIS items and a Tharstern-era order's: dated lines, newest first,
// at the foot of the item's detail.

export interface HistoryLine {
  at: string;
  text: string;
}

export function ItemHistory({ lines }: { lines: HistoryLine[] }) {
  if (lines.length === 0) return null;
  return (
    <div className="space-y-2 border-t pt-3">
      <p className="text-sm font-medium">History</p>
      <ol className="space-y-1 text-xs text-muted-foreground">
        {lines.map((h, i) => (
          <li key={i} className="flex gap-3">
            <span className="w-24 shrink-0 tabular-nums">
              {formatWeekdayDateOrDash(h.at)}
            </span>
            <span>{h.text}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
